<template>
    <div class="hello">
        <div class="hello__body">
            <div class="hello__title">
                В ваших планах — <br>
                мировое <br>
                господство?
            </div>
            <div class="hello__description">
                Начните с покорения мирового рынка! Жмите «Захватить мир» и начинайте экспансию через <a target="_blank" :href="$store.state.links.ebay">eBay</a>.
                Продавать вы будете ушки малыша Йоды, чеканные монеты для Ведьмака и боль Гарольда.
                Цель игры — показать всем, кто тут король продаж!
                Рекомендуем не пролистывать правила игры — в них мы даем советы.
            </div>
            <a class="ui-btn theme-light border bold icon hello__btn" @click="onNext">
                Захватить мир
                <icon-arrow-right class="hello__btn-icon" />
            </a>
            <div class="hello__map">
                <block-map></block-map>
                <block-event class="hello__event" :class="{animate: initAnimate}" :id="1" />
                <block-event class="hello__event" :class="{animate: initAnimate}" :id="2" />
                <block-event class="hello__event" :class="{animate: initAnimate}" :id="3" />
            </div>
        </div>
    </div>
</template>

<script>
    import analytics from '@/utils/analytics.js'

    export default {
        components: {},
        data () {
            return {
                initAnimate: false
            }
        },
        methods: {
            onNext () {
                analytics.getPixel('https://ads.adfox.ru/260477/getCode?p1=ccqdp&p2=frfe&pfc=cvroc&pfb=hujgr&pr=%random%&ptrc=b\n')
                this.$router.push({name: 'game-goods'})
            }
        },
        mounted () {
            setTimeout(() => {
                this.initAnimate = true
            }, 50)
        }
    }
</script>

<style lang="stylus" scoped>
    .hello {
        position absolute
        top 0
        left 0
        right 0
        z-index 200
        bottom 0
        overflow hidden
        width 100%
        min-height 65rem
        padding 5rem 6rem
        background-color #362aee
        top -5.7rem

        +layout-sm() {
            top 0
            padding 4.3rem 2rem 6rem 2rem
            position static
            +layout-xs() {
                position relative
            }
        }

        &__body {
            position relative
            z-index 20
        }

        &__title {
            font-weight $font-bold
            font-size 5rem
            line-height 5.2rem
            color $color-accent
            +layout-xs() {
                font-size 2.7rem
                line-height 3rem
            }
        }

        &__description {
            margin-top 2.4rem
            font-size 1.8rem
            line-height 2.6rem
            max-width 43rem
            +layout-sm() {
                max-width 100%
            }
            +layout-xs() {
                font-size 1.6rem
                line-height 2.4rem
                margin-top 1.8rem
            }
            a {
                color #ffffff
                font-weight $font-bold
            }
        }

        &__btn {
            margin-top 3rem
            width 26.5rem
            height 7.7rem
            +layout-xxs() {
                width 100%
                margin-top 2.7
            }

            &-icon {
                margin-left 0.7rem
                position relative
                top 0.1rem
                display flex
                width 1rem
                height 1.2rem
            }
        }

        &__map {
            position absolute
            z-index -1
            top 20.2%
            right -26.1rem
            width 68.5rem
            +layout-sm() {
                top 40%!important
                bottom 0!important
                right 0!important
                width 50rem!important
            }
            +layout-xs() {
                top auto!important
                bottom -36%!important
                right -32rem!important
                transform scale(1.18)
            }
        }

        &__map &__event {
            position absolute
            z-index 10
            transform scale(0)
            opacity 0
            transition transform 0.4s cubic-bezier(0.82, 0.28, 0.27, 1.63), opacity 0.6s ease

            +layout-sm() {
                display none
            }

            &:nth-child(2) {
                top 11.8rem
                left 38.9rem
                &.animate {
                    transform scale(1.2)
                    opacity 1
                    transition-delay .2s
                }
            }

            &:nth-child(3) {
                top 24.1rem
                left 20.4rem
                &.animate {
                    transform scale(0.8)
                    opacity 1
                    transition-delay .8s
                }

                >>> .block-event__img {
                    position relative
                    top 0.2rem
                }
            }

            &:nth-child(4) {
                top -2.8rem
                left 28.5rem
                &.animate {
                    transform scale(1.5)
                    opacity 1
                    transition-delay .5s
                }

                >>> .block-event__img {
                    position relative
                    top 0.2rem
                }
            }
        }
    }
</style>
